<template>
    <a
        v-animation:bottom.delay
        v-link
        :href="data.link"
        :class="[{ _color: data.color }, classItem, 't-card__item']"
        :style="'background-color: ' + data.color + ';'"
        :key="data.id"
    >
        <div v-if="data.img && !data.color" class="t-card__img">
            <img
                v-if="classItem === '_media'"
                @load="$redrawVueMasonry()"
                :src="data.img"
                :alt="data.title"
            />
            <img v-else :src="data.img" :alt="data.title"/>
        </div>
        <div class="t-card__wrap">
            <div class="t-card__row">
                <div class="t-card__date" v-text="data.date"></div>
                <div v-if="data.countViews" class="t-card__count">
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.8" clip-path="url(#clip0)">
                            <path d="M9.80031 5.25C13.3636 5.25 15.8476 7.509 16.9283 8.727C15.8776 10.1047 13.3936 12.75 9.80031 12.75C6.48531 12.75 3.85281 10.098 2.69181 8.69475C3.81156 7.4595 6.30456 5.25 9.80031 5.25ZM9.80031 3.75C4.12356 3.75 0.789062 8.66325 0.789062 8.66325C0.789062 8.66325 4.41531 14.25 9.80031 14.25C15.6001 14.25 18.7891 8.66325 18.7891 8.66325C18.7891 8.66325 15.5708 3.75 9.80031 3.75ZM9.78906 7.5C10.6163 7.5 11.2891 8.17275 11.2891 9C11.2891 9.82725 10.6163 10.5 9.78906 10.5C8.96181 10.5 8.28906 9.82725 8.28906 9C8.28906 8.17275 8.96181 7.5 9.78906 7.5ZM9.78906 6C8.13231 6 6.78906 7.344 6.78906 9C6.78906 10.6568 8.13231 12 9.78906 12C11.4458 12 12.7891 10.6568 12.7891 9C12.7891 7.344 11.4458 6 9.78906 6Z" fill="#929292"/>
                        </g>
                        <defs>
                            <clipPath id="clip0">
                                <rect width="18" height="18" fill="white" transform="translate(0.789062)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="t-card__number" v-text="data.countViews"></div>
                </div>
            </div>
            <div class="t-card__title t-subtitle t-clamp-4" v-text="data.title"></div>
            <div class="t-card__desc t-clamp-5" v-text="data.description"></div>

            <div
                v-if="data.source"
                class="t-card__source"
                v-text="sourceTitle + ': ' + data.source"
            ></div>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'card',
        props: {
            data: Object,
            classItem: String,
            sourceTitle: String,
        },
    };
</script>



// WEBPACK FOOTER //
// src/templates/components/ui-components/card/card.vue